<ion-header [translucent]="true">
  <ion-toolbar class="navbar bg-fill-secondary">
    <ion-buttons slot="start">
      <ion-menu-button style="width: fit-content !important;" class="slide-btn"></ion-menu-button>
    </ion-buttons>



    <div style="width: max-content;">
      <svg class="home-logo" *ngIf="!showHomeElements" (click)="redirectToHome()" style="fill:white;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M575.8 255.5c0 18-15 32.1-32 32.1l-32 0 .7 160.2c0 2.7-.2 5.4-.5 8.1l0 16.2c0 22.1-17.9 40-40 40l-16 0c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1L416 512l-24 0c-22.1 0-40-17.9-40-40l0-24 0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 64 0 24c0 22.1-17.9 40-40 40l-24 0-31.9 0c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2l-16 0c-22.1 0-40-17.9-40-40l0-112c0-.9 0-1.9 .1-2.8l0-69.7-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"/></svg>
      <img src="../assets/icon/logo.png"  class="logo">
    </div>

    <div slot="end" class="d-flex">

      <div class="d-flex">
        <ion-title class="navbar-brand" style="padding: 0;align-self: center;font-size: 0.9rem;text-align: center;margin-right: 0.4rem;">
          <span class="watch-Live live btn " (click)="watchLiveVideos()" >{{'COMPONENTS.HEADDER.BUTTONS.WATCH_LIVE' | translate}}</span>
        </ion-title>
      </div> 

      <div>
        <div class="language-div">
          <p (click)="changeLang('en')" ><span  [ngClass]="{'lanHover':selectedLanguage == 'en'}">EN</span></p>
          <p (click)="changeLang('si')" style="margin-left: 4px;">| <span [ngClass]="{'lanHover':selectedLanguage == 'si'}">සිං</span></p>
          <p (click)="changeLang('tm')" style="margin-left: 4px;">| <span [ngClass]="{'lanHover':selectedLanguage == 'tm'}">தமி</span></p>
        </div>
   
        <ion-buttons slot="end" *ngIf="!is_logged && !is_registered" style="float: right;">
          <button class="btn btn-fill-primary" (click)="launchLogin()"> {{ 'COMPONENTS.HEADDER.BUTTONS.JOIN' | translate }} </button>
        </ion-buttons>
    
        <ion-buttons slot="end" *ngIf="is_logged" style="float: right;">
          <button class="btn btn-fill-primary"
            style="padding-top: 1px;padding-bottom: 1px;padding-left: 6px;padding-right: 4px;">
            <ion-icon size="large" name="exit-outline" (click)="click_logout()" style="width: 24px;height: 22px;"></ion-icon>
          </button>
        </ion-buttons>
    
        <ion-buttons slot="end" *ngIf="is_registered && !is_logged" style="float: right;">
          <button class="btn btn-fill-primary" (click)="launchLogin()"> {{ 'COMPONENTS.HEADDER.BUTTONS.LOG_IN' | translate }} </button>
        </ion-buttons>
      </div>

    </div>
    

  </ion-toolbar>
</ion-header>